import { ref } from 'vue';

export type PortalTheme = 'light' | 'dark' | 'system';
export const PORTAL_THEME_KEY = 'Developer-Portal-Theme';
export const portalTheme = ref<PortalTheme>('light');
let media: MediaQueryList | undefined;
let active = false;

export const normalizePortalTheme = (value: unknown): PortalTheme => (value === 'dark' || value === 'system' ? value : 'light');

const applyTheme = () => {
  if (!active) return;
  document.documentElement.dataset.portalTheme = portalTheme.value === 'system' ? (media?.matches ? 'dark' : 'light') : portalTheme.value;
};

const readPreference = () => {
  try {
    return normalizePortalTheme(localStorage.getItem(PORTAL_THEME_KEY));
  } catch {
    return 'light';
  }
};

const onStorage = (event: StorageEvent) => {
  if (event.key !== PORTAL_THEME_KEY && event.key !== null) return;
  portalTheme.value = readPreference();
  applyTheme();
};

/** Scope portal colors to portal routes; never change the IoT theme or its storage. */
export const activatePortalTheme = (enabled: boolean) => {
  if (enabled && !active) {
    active = true;
    portalTheme.value = readPreference();
    media = window.matchMedia('(prefers-color-scheme: dark)');
    media.addEventListener('change', applyTheme);
    window.addEventListener('storage', onStorage);
  } else if (!enabled && active) {
    active = false;
    media?.removeEventListener('change', applyTheme);
    window.removeEventListener('storage', onStorage);
    media = undefined;
    delete document.documentElement.dataset.portalTheme;
  }
  applyTheme();
};

export const setPortalTheme = (value: PortalTheme) => {
  portalTheme.value = normalizePortalTheme(value);
  try {
    localStorage.setItem(PORTAL_THEME_KEY, portalTheme.value);
  } catch {
    // A blocked browser store must not prevent changing the current theme.
  }
  applyTheme();
};
